module.exports = __webpack_public_path__ + "assets/favicons/mstile-150x150.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/mstile-150x150.png
// module id = 1241
// module chunks = 1